export const selectExceptions = (state) => state.exceptions.exceptions;
export const selectExceptionLevels = (state) => state.exceptions.exceptionLevels;

export const selectExceptionsLoading = (state) => state.exceptions.loading;
export const selectExceptionLevelsLoading = (state) => state.exceptions.loadingLevels;